export const navLinks = [
  { id: 'hot', label: '今日热榜' },
  { id: 'articles', label: '观点随笔' },
  { id: 'columns', label: '栏目专题' },
  { id: 'rambling', label: '碎碎念' },
  { id: 'about', label: '关于我' },
  { id: 'faq', label: '常见问题' },
];

export interface Topic {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  trend: string;
  take: string;
}

export const hotTopics: Topic[] = [
  { rank: 1, title: '被热搜"洗脑"的一周，我到底吃了几个瓜？', tag: '社会热点', heat: 98, trend: 'up', take: '同一个事件刷到第七遍，我忽然意识到：热搜真正喂养的，不是我的好奇心，而是我的焦虑感。' },
  { rank: 2, title: '关于那场全网刷屏的综艺争议，我想说点反话', tag: '娱乐八卦', heat: 91, trend: 'up', take: '当所有人都站队时，我反而想问问：我们到底是在吃瓜，还是在借别人的故事完成自己的情绪宣泄？' },
  { rank: 3, title: '大厂裁员风暴里的普通打工人', tag: '职场观察', heat: 84, trend: 'up', take: '新闻里的数字是一个个被裁的人，而吃瓜之外的你我，或许下一秒就会成为那个数字。' },
  { rank: 4, title: '爆火的AI产品背后，藏着多少"伪需求"？', tag: '科技趋势', heat: 79, trend: 'down', take: '热度过去之后，留下的才是真需求。我用一个月时间试用了几十个AI产品，只说真话。' },
  { rank: 5, title: '小县城青年回村后的"慢生活"是解药吗？', tag: '生活方式', heat: 72, trend: 'up', take: '逃离大城市听起来很美，但围城之外，会不会又是另一座围城？我决定亲自回去住了一个月。' },
  { rank: 6, title: '明星塌房时，谁在为"人设"买单？', tag: '娱乐八卦', heat: 65, trend: 'down', take: '我们爱上的从来不是一个人，而是一个精心包装的剧本角色。角色破碎时，真正的受害者恰恰是我们自己。' },
];

export interface Article {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  author: string;
  views: string;
  cover: string;
  highlight?: boolean;
  body: string[];
}

export const categories = ['全部', '社会热点', '娱乐八卦', '职场观察', '科技趋势', '生活方式'];

export const articles: Article[] = [
  {
    id: 1,
    category: '社会热点',
    title: '同一件事刷屏七遍，我该如何保持清醒？',
    excerpt: '在信息过载的时代，我们缺的不是瓜，而是判断力。这篇聊聊我的「三问筛选法」。',
    date: '2026-09-06',
    readTime: '6 分钟',
    author: '吾爱吃瓜',
    views: '12.4k',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20editorial%20illustration%20of%20a%20young%20person%20holding%20a%20smartphone%20swamped%20by%20floating%20news%20bubbles%20and%20headlines%2C%20cream%20paper%20background%2C%20watermelon%20red%20and%20leaf%20green%20accents%2C%20minimal%20flat%20vector%20style%2C%20soft%20shadows%2C%20cozy%20reading%20mood&width=900&height=560&seq=art-hot-01&orientation=landscape',
    highlight: true,
    body: [
      '我承认，我是一个重度吃瓜爱好者。每天醒来第一件事，就是打开热榜，看看昨晚错过了什么大新闻。可渐渐地，我发现一个让自己后背发凉的现象：同一个事件，我明明已经在不同平台刷到了七遍，却仍然无法真正说清它到底发生了什么。',
      '问题出在哪？我认真复盘过自己的一整天，从早晨的通勤刷手机，到午休时的摸鱼，再到深夜睡前的"最后一刷"。这些时间碎片被无数条推送填满，表面上我很充实，实际上我只是在被算法牵着鼻子走，把别人的节奏误当成了自己的思考。',
      '于是我给自己立了一套「三问筛选法」：第一问，这条消息对我有价值吗？第二问，除了眼前这个说法，是否还有其他来源可交叉印证？第三问，看完之后，我能否用自己的话复述出事件的核心？三条都过关，才算真正"吃懂"一个瓜。',
      '这套方法未必完美，但它让我从被动接收变成了主动选择。热点永远层出不穷，而我们的精力有限。与其被碎片追着跑，不如慢下来，真正读懂一两件值得关心的事。吃瓜是乐趣，但不是生活的全部。',
    ],
  },
  {
    id: 2,
    category: '娱乐八卦',
    title: '全网刷屏的综艺争议，我想说点反话',
    excerpt: '当所有人都在站队，理性与共情往往被情绪淹没。这篇是我逆着人流写下的一点真实想法。',
    date: '2026-09-03',
    readTime: '7 分钟',
    author: '吾爱吃瓜',
    views: '9.8k',
    cover: 'https://readdy.ai/api/search-image?query=A%20flat%20editorial%20illustration%20of%20two%20sides%20of%20a%20debate%20facing%20each%20other%20across%20a%20stage%2C%20silhouettes%20with%20speech%20bubbles%20clashing%2C%20warm%20coral%20and%20amber%20tone%20on%20cream%20background%2C%20minimal%20modern%20vector%2C%20thoughtful%20mood&width=900&height=560&seq=art-ent-02&orientation=landscape',
    body: [
      '综艺节目能引发如此大规模的网络讨论，这本身就值得玩味。当我把各种平台的热评都翻了一遍，发现大多数人都笃定地站在某一方，用几乎相同的句式复述着相同的观点。这让我隐约感到不安。',
      '我并非要唱反调，只是想提醒自己也提醒大家：屏幕里的剪辑、剧本与人设，决定了我们看到的永远是"被加工过的真相"。我们基于片面的信息做出的道德审判，真的足够公允吗？',
      '诚然，公众对节目的监督有一定价值，但当情绪盖过事实、标签取代论证时，所谓的"正义讨论"就可能滑向网络暴力。我见过太多被群嘲的人，后来被证明其实是受害者。反转，正是这个时代最常见的剧本。',
      '所以我的态度是：可以吃瓜，可以讨论，但请保留一点克制的怀疑。在没有看到完整证据之前，先别急着给任何人盖章定论。给别人留一点余地，也是给自己的判断力留一点体面。',
    ],
  },
  {
    id: 3,
    category: '职场观察',
    title: '大厂裁员风暴里，普通打工人如何自处？',
    excerpt: '数字背后的每一个名字，都曾是某个家庭的顶梁柱。聊聊打工人的焦虑、选择与自救。',
    date: '2026-08-28',
    readTime: '9 分钟',
    author: '吾爱吃瓜',
    views: '15.2k',
    cover: 'https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20illustration%20of%20an%20office%20worker%20walking%20out%20of%20a%20glass%20building%20carrying%20a%20cardboard%20box%2C%20carrying%20plants%20and%20personal%20items%2C%20warm%20neutral%20cream%20palette%20with%20watermelon%20red%20accents%2C%20flat%20vector%2C%20reflective%20and%20calm%20tone&width=900&height=560&seq=art-work-03&orientation=landscape',
    highlight: true,
    body: [
      '当我第一次看到那串刺眼的裁员数字时，第一反应是心疼。新闻简报只会用冰冷的数据一笔带过，可每一个数字背后，都是一个鲜活的普通人，一个家庭的顶梁柱，一段需要重新开始的人生。',
      '这几年，互联网的红利期正在退潮，曾经"大厂=铁饭碗"的神话也随之破灭。我想聊的不是焦虑贩卖，而是一种更务实的自处之道：把安全感从公司身上，一点点收回自己身上。',
      '我的几个真实建议：第一，保持一项离开平台仍能吃饭的核心技能；第二，定期梳理自己的作品与成果，而不是把功劳都记在组织头上；第三，适度经营副业与人脉，给自己多留几条退路。',
      '说实话，这些道理听起来老生常谈，但真正做到的人寥寥无几。真正的职业安全感，从来不来自一份稳定的工作，而来自随时可以重新出发的能力。这才是我想和每一个打工人共勉的清醒。',
    ],
  },
  {
    id: 4,
    category: '科技趋势',
    title: '爆火的AI产品背后，藏着多少"伪需求"？',
    excerpt: '我用了一个月试用几十个AI工具，热度退潮后，说说哪些是真方便，哪些只是噱头。',
    date: '2026-08-22',
    readTime: '8 分钟',
    author: '吾爱吃瓜',
    views: '11.1k',
    cover: 'https://readdy.ai/api/search-image?query=A%20flat%20editorial%20illustration%20of%20multiple%20AI%20robot%20icons%20and%20floating%20app%20windows%20with%20some%20fading%20away%20like%20bubbles%2C%20cream%20background%2C%20green%20and%20warm%20amber%20accents%2C%20minimal%20modern%20vector%2C%20analytical%20mood&width=900&height=560&seq=art-tech-04&orientation=landscape',
    body: [
      'AI无疑是我近一年来见过最猛的风口。打开任何应用商店，几乎每天都有新的AI产品上线，个个宣称自己是"生产力革命"。带着好奇，我下载并认真试用了几十个工具，想看看它们到底是真金还是泡沫。',
      '一个月的体验下来，我的结论有点反直觉：真正解决问题的AI工具，往往低调到不怎么做营销；而大量高调刷屏的产品，解决的反而是"伪需求"——它们制造了一个需要AI才能完成的任务，然后反过来推销解决方案。',
      '举例来说，真正帮到我的，是那些嵌入日常流程的工具：帮我校对文字的、整理会议纪要的、辅助我梳理思路的。它们不喧哗，却实打实省下了我的时间。而那些需要我先改变习惯去"适应它"的产品，大多在一周内被我卸载。',
      '我的建议很简单：不要为炫技买单，只为核心效率付费。先想清楚自己真实存在的问题，再去找对应的工具，而不是反过来被产品经理的故事牵着走。技术浪潮年年有，真正留下来的，永远是解决真实痛点的那个。',
    ],
  },
  {
    id: 5,
    category: '生活方式',
    title: '回村住了一个月，我才真正看懂"慢生活"',
    excerpt: '逃离大城市听起来很美，可围城之外或许也是围城。这是我的亲身体验与真心话。',
    date: '2026-08-15',
    readTime: '10 分钟',
    author: '吾爱吃瓜',
    views: '18.7k',
    cover: 'https://readdy.ai/api/search-image?query=A%20serene%20editorial%20illustration%20of%20a%20rural%20courtyard%20with%20warm%20sunlight%2C%20a%20wooden%20table%20with%20teacups%20and%20watermelon%20slices%2C%20green%20hills%20in%20background%2C%20cream%20and%20green%20palette%2C%20flat%20vector%2C%20peaceful%20and%20nostalgic&width=900&height=560&seq=art-life-05&orientation=landscape',
    highlight: true,
    body: [
      '在城市的高楼里待久了，我常听人谈论"逃离"。他们说回村、返乡、慢生活，仿佛只要离开格子间，所有烦恼都会随风消散。于是我真的请了一个月的假，回到南方小镇的老家，用亲身体验去验证这个传说。',
      '头几天确实很治愈。没有早高峰，没有没完没了的消息提醒，清晨被鸟叫唤醒，傍晚能看见橙色的晚霞。我一度以为，我终于找到了答案。可新鲜感褪去后，新的问题浮现了：这里没有我要去的图书馆，没有想见的同行，连深夜想吃碗像样的面都成了难题。',
      '我开始意识到，"慢生活"的本质从来不是换个地方，而是一种主动选择的生活节奏。有人在热闹的一线城市里也能守住内心的秩序，也有人回到小镇却依然被空虚追着跑。城市与乡村只是容器，真正的自由在于你如何安排自己的时间与欲望。',
      '这一个月没有给我标准答案，却让我更了解自己。我依然喜欢城市带来的可能性，却也学会了在快节奏里给自己留一点喘息。生活没有固定的最佳答案，只有最适合自己的那一种。愿你也能找到属于自己的节奏。',
    ],
  },
  {
    id: 6,
    category: '职场观察',
    title: '加班到底为了什么？聊聊"假装努力"',
    excerpt: '深夜的朋友圈灯火通明，可很多人只是用勤奋来掩饰方向感的缺失。说几句扎心的大实话。',
    date: '2026-08-08',
    readTime: '5 分钟',
    author: '吾爱吃瓜',
    views: '8.3k',
    cover: 'https://readdy.ai/api/search-image?query=A%20flat%20editorial%20illustration%20of%20a%20person%20at%20a%20desk%20late%20at%20night%20with%20a%20lamp%20and%20computer%20glow%2C%20yawning%2C%20warm%20dark%20amber%20tones%20with%20cream%20background%2C%20minimal%20vector%2C%20melancholic%20yet%20honest%20mood&width=900&height=560&seq=art-work-06&orientation=landscape',
    body: [
      '我见过太多这样的人：凌晨一点还在朋友圈晒加班，配文写着"努力到无能为力"。可熟悉他们的人都知道，他们白天刷了两个小时的短视频，真正专注工作的时间加起来可能不到半天。',
      '这不是要嘲讽谁，因为我也曾经是其中的一员。我们太容易把"忙碌"等同于"努力"，把"待在工位的时间"当作"产出的价值"。可深夜的灯火通明，如果只是为了安慰自己，那不过是另一种形式的自我欺骗。',
      '真正让我警醒的，是我开始追问自己"为什么加班"的那一刻。是为了把一个项目做到更好，还是因为白天不够专注、不得不晚上补救？是为了解决问题，还是为了在领导面前表现态度？答案不同，这份加班的意义也天差地别。',
      '我写这些，是想给同样疲惫的你提个醒：与其用战术上的勤奋，掩盖战略上的懒惰，不如先想清楚自己真正想去的地方。没有方向的努力是自我消耗，有方向的努力才叫积累。愿你做的每一份努力，都配得上你想要的结果。',
    ],
  },
];

export interface Column {
  name: string;
  title: string;
  desc: string;
  count: string;
  icon: string;
}

export const columns: Column[] = [
  { name: '吃瓜热评', title: '追着热点，说着人话', desc: '第一时间下场，用普通人视角拆解热搜背后的情绪与逻辑。', count: '128 篇', icon: 'ri-fire-fill' },
  { name: '职场坦白局', title: '打工人的真心话', desc: '不贩卖焦虑，只讲大厂、裁员、加班与自我成长的真实经验。', count: '86 篇', icon: 'ri-briefcase-4-fill' },
  { name: '科技看门道', title: '新事物，冷思考', desc: 'AI与科技产品迭代再快，也挡不住我一双冷静观察的眼睛。', count: '64 篇', icon: 'ri-robot-2-fill' },
  { name: '生活漫游记', title: '慢下来，再出发', desc: '城市与远方之间，记录那些让生活重新发光的琐碎瞬间。', count: '95 篇', icon: 'ri-route-fill' },
];

export const ramblings = [
  { text: '今天吃到一个又大又甜的瓜，结果发现是营销号编的。营销号，你们欠我的是情绪价值！', tag: '日常' },
  { text: '看评论区的争吵，忽然觉得互联网像个巨大的情绪回收站，人人都在往里倒垃圾，却没人愿意分类。', tag: '感悟' },
  { text: '劝你别熬夜刷手机了，真话是：你看的那些瓜，明天醒来一个都记不住，只有黑眼圈记得。', tag: '碎碎念' },
  { text: '学会一项新技能的第 21 天，那种笨拙又上头的感觉，比刷一百个瓜还快乐。', tag: '成长' },
  { text: '被甲方改了八版方案，第九版回到了第一版。别问，问就是"还是最初的感觉最好"。', tag: '职场' },
  { text: '雨天在家煮一锅热汤，窗外的雨声比任何白噪音都好听。原来幸福可以这么便宜。', tag: '生活' },
];

export const stats = [
  { value: '380+', label: '原创随笔' },
  { value: '120w+', label: '累计阅读' },
  { value: '6 年', label: '持续输出' },
  { value: '42k', label: '关注同好' },
];

export const testimonials = [
  { text: '关注吾爱吃瓜三年了，不是因为他每篇都对，而是因为他敢说别人不敢说的实话，哪怕不讨喜。', who: '一位老读者', role: '普通打工人' },
  { text: '在信息爆炸的当下，难得有一个愿意慢下来把一件事讲清楚的声音。他的观点我未必全认同，但尊重。', who: '匿名网友', role: '互联网从业者' },
  { text: '最喜欢他的职场坦白局，不鸡汤、不焦虑，像有个懂行的老朋友坐在对面跟我唠嗑。', who: '隔壁老王', role: '北漂青年' },
];

export const faqs = [
  {
    q: '吾爱吃瓜是一个什么样的网站？',
    a: '吾爱吃瓜是一个以个人视角撰写的内容博客。我不代表任何机构，只从自己真实的观察和经历出发，围绕社会热点、职场、科技与生活方式分享看法、吃瓜心得与碎碎念。这里的每篇文章都带有明显的主观色彩，也是它区别于资讯平台的地方。',
  },
  {
    q: '这里的观点是客观事实吗？',
    a: '不是。我会在文中尽力区分"事实"与"我的看法"，但核心价值恰恰在于主观的视角与判断。如果你需要权威、中立的资讯，建议同时参考主流媒体报道，再回来一起碰撞观点。',
  },
  {
    q: '文章多久更新一次？',
    a: '通常每周更新 3 至 4 篇，热点事件发生时可能会临时加更。你可以订阅下方的资讯，新文章发布时会第一时间通过邮件通知你，不错过任何一次吃瓜现场。',
  },
  {
    q: '我可以投稿或一起讨论吗？',
    a: '当然可以。如果你对某个话题有不同看法，欢迎通过页面下方的联系方式或订阅邮箱写信给我。好的观点值得被听见，我也会挑选有价值的来信在后续文章中回应。',
  },
  {
    q: '文章可以转载吗？',
    a: '欢迎在注明出处与原作者的前提下以非商业用途转载。若要商业转载或合作，请先通过邮箱与我联系并获得授权，这是对我持续创作最基本的尊重。',
  },
];

export const footerLinks = {
  快速导航: ['今日热榜', '观点随笔', '栏目专题', '碎碎念', '关于我', '常见问题'],
  热门栏目: ['吃瓜热评', '职场坦白局', '科技看门道', '生活漫游记'],
  联系方式: ['about@wuaichigua.example', '每周二、五晚更新', '欢迎来信交流观点'],
};

export const socials = [
  { icon: 'ri-wechat-fill', label: '微信公众号' },
  { icon: 'ri-weibo-fill', label: '微博' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
  { icon: 'ri-mail-fill', label: '邮件订阅' },
  { icon: 'ri-rss-fill', label: 'RSS 订阅' },
];